import { UseFormSetValue } from 'react-hook-form';

interface UseModalHandlersProps {
  setActiveFreelancerForCalendar: (value: string) => void;
  setShowCalendar: (value: boolean) => void;
  setCurrentDeductionFreelancerId: (value: string) => void;
  setEditingDeductionIndex: (value: number | null) => void;
  setEditingDeductionData: (value: any) => void;
  setShowDeductionModal: (value: boolean) => void;
  setEditingCopiedWorkingHourIndex: (value: number | null) => void;
  deductionsByFreelancer: { [key: string]: any[] };
  setExpandedSections: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;
  setValue: UseFormSetValue<any>;
  setShowTooltipError?: (value: any) => void;
}

export const useModalHandlers = ({
  setActiveFreelancerForCalendar,
  setShowCalendar,
  setCurrentDeductionFreelancerId,
  setEditingDeductionIndex,
  setEditingDeductionData,
  setShowDeductionModal,
  setEditingCopiedWorkingHourIndex,
  deductionsByFreelancer,
  setExpandedSections,
  setValue,
  setShowTooltipError,
}: UseModalHandlersProps) => {
  
  const handleCalendarOpen = (freelancerId: string = 'default') => {
    setActiveFreelancerForCalendar(freelancerId);
    setShowCalendar(true);
  };

  const handleCalendarClose = () => {
    setShowCalendar(false);
  };

  const handleOpenDeductionModal = (freelancerId: string = 'default', deductionIndex: number | null = null) => {
    setCurrentDeductionFreelancerId(freelancerId);
    setEditingDeductionIndex(deductionIndex);
    
    if (deductionIndex !== null) {
      const deductionToEdit = deductionsByFreelancer[freelancerId]?.[deductionIndex];
      setEditingDeductionData(deductionToEdit);
    } else {
      setEditingDeductionData(null);
    }
    
    setShowDeductionModal(true);
  };

  const handleCloseDeductionModal = () => {
    setShowDeductionModal(false);
    setEditingDeductionIndex(null);
    setEditingDeductionData(null);
    setEditingCopiedWorkingHourIndex(null);
  };

  const toggleSection = (section: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleInputChange = (fieldName: string, value: any) => {
    setValue(fieldName, value);
    if (setShowTooltipError && fieldName) {
      setShowTooltipError((prev: any) => ({ ...prev, [`null${fieldName}`]: false }));
    }
  };

  return {
    handleCalendarOpen,
    handleCalendarClose,
    handleOpenDeductionModal,
    handleCloseDeductionModal,
    toggleSection,
    handleInputChange,
  };
};
